import { createActions } from "reduxsauce";

export default createActions(
  {
    generalInfoUpdated: ["values"],
    userFetched: ["user"],
    setConsent: ["consent"]
  },
  { prefix: "user/" }
);



// WEBPACK FOOTER //
// ./src/modules/user/user-actions.js